import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Деньги для агробизнеса\nбез ежемесячных платежей',
  button: {
    sendRequest: 'Подать заявку',
    moreDetails: 'Подробнее',
  },
  customComment: 'Баннер главной ЛК',
  logo: 'Логотип "Поле Финанс"',
} satisfies TMessages
